var React = require('react');

function ArrowAltToBottomLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M230.9 64c8.8 0 16 7.2 16 16v144h93.9c7.1 0 10.7 8.6 5.7 13.6L203.3 381.2c-6.3 6.3-16.4 6.3-22.7 0l-143-143.6c-5-5-1.5-13.6 5.7-13.6h93.9V80c0-8.8 7.2-16 16-16h77.7m0-32h-77.7c-26.5 0-48 21.5-48 48v112H43.3c-35.5 0-53.5 43-28.3 68.2l143 143.6c18.8 18.8 49.2 18.8 68 0l143.1-143.5c25.1-25.1 7.3-68.2-28.3-68.2h-61.9V80c0-26.5-21.6-48-48-48zM384 468v-8c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12z"}));
}

ArrowAltToBottomLight.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fal","data-icon":"arrow-alt-to-bottom","className":"svg-inline--fa fa-arrow-alt-to-bottom fa-w-12","role":"img","viewBox":"0 0 384 512"};

module.exports = ArrowAltToBottomLight;

ArrowAltToBottomLight.default = ArrowAltToBottomLight;
